// ** React Imports
import { Fragment, useState } from "react";

// ** Components
import CalendarComponent from "./Calendar";

// ** Custom Components
import Breadcrumbs from "@components/breadcrumbs";

// ** Styles
import "@styles/react/apps/app-ecommerce.scss";
import Header from "./Header";
import TableData from "./TableData";

const FlexTimeCheckSubordinate = () => {
  // ** States
  const [activeView, setActiveView] = useState("calendar");

  return (
    <Fragment>
      <Breadcrumbs
        title="Subordinate Flex Time"
        data={[{ title: "Subordinate Flex Time" }]}
        menu="Flex Time"
      />

      <Header setActiveView={setActiveView} activeView={activeView} />

      {activeView === "calendar" ? <CalendarComponent /> : <TableData />}
      {/* {activeView === "calendar" ? <CalendarComponent /> : null} */}
    </Fragment>
  );
};

export default FlexTimeCheckSubordinate;
